module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main_title t_style a_left s_title mt50"
  }, [_c('div', {
    staticClass: "c_inner"
  }, [_c('h2', {
    staticClass: "c_title"
  }, [_vm._v("ROOM SERVICES")])])]), _vm._v(" "), _c('div', {
    staticClass: "room_facilitys_list"
  }, [_c('div', {
    staticClass: "all_facility_list"
  }, [_c('div', {
    staticClass: "col-sm-4 nopadding"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("Double Bed")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("80 Sq mt")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("6 Persons")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("Free Internet")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 nopadding"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("Free Wi-Fi")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("Breakfast Include")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("Private Balcony")]), _vm._v(" "), _c('li', {
    staticClass: "no"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v("Free Newspaper")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 nopadding_left"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "no"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v("Flat Screen Tv")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("Full Ac")]), _vm._v(" "), _c('li', {
    staticClass: "no"
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v("Beach View")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("Room Service")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10e67b9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/singleRoom/sections/roomServices.vue
// module id = 349
// module chunks = 0